import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { later } from '@ember/runloop';
import { action, computed } from '@ember/object';
import { getOwner } from '@ember/application';

export default class MwEventListItemSimple extends Component {
  @service router;
  @service dynamicDialogs;

  @computed('args.rootEventId', 'args.eventData.id')
  get isCurrentEvent() {
    return this.args.rootEventId === this.args.eventData.id;
  }

  @action
  eventClick() {
    if (this.isCurrentEvent && this.args.eventData.unreadPostsCount) {
      later(
        this,
        function () {
          if (this.isDestroying || this.isDestroyed) return;
          let route = getOwner(this).lookup(`route:app.event.feed`);
          if (route) route.send('refreshFeed');
        },
        80
      );
    }

    window.scrollTo(0, 0);
  }
}
